import React from 'react';
import { useParams } from 'react-router-dom';


import Layout from '../../components/web/Layout';
import MedicalAidFormFamilyMember from '../../components/web/form/MedicalAidFormFamilyMember';
import LifetimeMembershipForm from '../../components/web/form/LifetimeMembershipForm';
import RetirementBenefitForm from '../../components/web/form/RetirementBenefitForm';
import NominationForm from '../../components/web/form/NominationForm';
import UpgradationMemberShipForm from '../../components/web/form/UpgradationMemberForm';
import ComplaintForm from '../../components/web/form/ComplaintForm';
import DeathApplicationForm from '../../components/web/form/DeathApplicationForm';
import MedicalAidForm from '../../components/web/form/MedicalAidForm';
import MembershipApplicationCD from '../../components/web/form/MembershipApplicationCD';
import MembershipApplicationArtDept from '../../components/web/form/MembershipApplicationArtDept';

function Form() {
  const { type } = useParams();

  let FormComponent;

  switch (type) {
    case 'NEW MEMBERSHIP APPLICATION - CD':
      FormComponent =
        <MembershipApplicationCD />;
      break;
    case 'NEW MEMBERSHIP APPLICATION ART DEPARTMENT':
      FormComponent =
        <MembershipApplicationArtDept />;
      break;
    case 'DEATH APPLICATION FORM':
      FormComponent =
        <DeathApplicationForm />;
      break;
    case 'MEDICAL AID APPLICATION FOR FAMILY MEMBER':
      FormComponent =
        <MedicalAidFormFamilyMember />;
      break;
    case 'MEDICAL AID APPLICATION FOR MEMBER':
      FormComponent =
        <MedicalAidForm />;
      break;
    case 'REGISTRATION (RETIREMENT BENEFIT SCHEME)':
      FormComponent =
        <RetirementBenefitForm />;
      break;
    case 'NOMINATION FORM':
      FormComponent =
        <NominationForm />;
      break;
    case 'UPGRADATION MEMBERSHIP APPLICATION FORM':
      FormComponent =
        <UpgradationMemberShipForm />;
      break;
    case 'COMPLAINT - FORM':
      FormComponent =
        <ComplaintForm />;
      break;
    case 'NEW MEMBERSHIP APPLICATION COSTUME DEPARTMENT':
      FormComponent =
        <MembershipApplicationCD />;
      break;

    default:
      FormComponent = <div>Invalid form type: {type}</div>;
  }

  return (
    <Layout>
      {FormComponent}
    </Layout>
  );
}

export default Form;
